import api from '../config/api';
import { network } from '../utils';

const getArticle = async () => {
  return await network({
    url: api.notification.type,
    method: 'get',
  });
};

export default getArticle;
